import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { authActions, selectIsLogoutDialogOpen, selectIsLogoutLoading } from '../store/authSlice';

const LogoutConfirmDialog: React.FC = () => {
  const isLogoutDialogOpen = useSelector(selectIsLogoutDialogOpen);
  const isLogoutLoading = useSelector(selectIsLogoutLoading);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleAgree = () => {
    dispatch(authActions.logout({ navigate }));
  };

  const handleDisagree = () => {
    dispatch(authActions.closeLogoutDialog());
  };

  return (
    <Dialog open={isLogoutDialogOpen} onClose={handleDisagree}>
      <DialogTitle>{t('LOGOUT_DIALOG.LOGOUT_DIALOG_TITLE')}</DialogTitle>
      <DialogContent>
        <DialogContentText>{t('LOGOUT_DIALOG.LOGOUT_DIALOG_QUESTION')}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button disabled={isLogoutLoading} onClick={handleDisagree}>
          {t('LOGOUT_DIALOG.NO')}
        </Button>
        <Button disabled={isLogoutLoading} onClick={handleAgree}>
          {isLogoutLoading && <CircularProgress size={20} sx={{ marginRight: '4px' }} />}
          {t('LOGOUT_DIALOG.YES')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LogoutConfirmDialog;
